import styled from 'styled-components';

import Link from '../../UI/Link/Link';
import variables from '../../../styles/variables';

export const ShoppingCart = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin: 0 0 0 0.5rem;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  width: 55px;
  height: 40px;

  img {
    width: 35px;
    height: 29px;
  }

  &.mobile-menu {
    position: absolute;
    right: 70px;
    margin: 0;
    width: 28px;
    height: 26px;

    img {
      width: 22.97px;
      height: 19.03px;
    }
  }
`;

export const ShoppingCartStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 5px;
  width: 25px;
  height: 25px;
  background: ${variables.colorRed};
  border-radius: 12.5px;

  @media screen and (max-width: 1024px) {
    right: 0;
  }

  span {
    font-size: 10px;
    font-weight: 600;
    color: ${variables.colorWhite};
  }

  &.mobile-menu {
    width: 16.41px;
    height: 16.41px;

    span {
      font-size: 6.5625px;
      line-height: 1rem;
    }
  }
`;

export const Popup = styled.p`
  cursor: default;
  color: ${variables.colorWhite};
  background-color: ${variables.colorBlackAlt};
  width: 125px;
  top: 110%;
  left: 50%;
  margin-left: -60px;
  text-align: center;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  position: absolute;
  z-index: 1;

  &::before {
    content: ' ';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
  }

  @media screen and (max-width: 1023px) {
    top: 120%;
    width: 130px;
    margin-left: -65px;
  }
`;
